import React from "react";
import Link from "next/link";
import { BlogPostPreview } from "./BlogPostPreview";

export const BlogCategoryContent = ({ data }) => {
  return <>
    <div className="responsive">
      <div className="flex text-xs uppercase my-3">
        <Link href={"/"} className="mr-3 hover:text-primary transition-colors">
          Home
        </Link>
        <span className="mr-3">/</span>
        <span className="text-muted font-bold">Blog</span>
      </div>
    </div>
    <div>
      {data.category.posts.map((node, index) => {
        return <BlogPostPreview data={node} key={`post-preview-${index}`} />;
      })}
    </div>
  </>;
};
